export function fixedFileSize (size) {
  return (size / 1024 / 1024).toFixed(1) + ' Мб'
}
